const initialState = {
  access_token: null,
  isAuthenticated: false,
  access: {
    can_full_access: false,
    can_read: false,
    can_write: false,
  },
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACCESS_TOKEN":
      return {
        ...state,
        access_token: action.payload,
        isAuthenticated: true,
      };

    case "SET_ACCESS":
      return {
        ...state,
        access: action.payload,
      };

    case "LOGOUT":
      return initialState;

    default:
      return state;
  }
};

export default authReducer;
